
CheckoutV2.Payment.PayPal = function(checkout, payment, extra, isReview) {
	var paypal = this;

	this.label = 'PayPal';
	this.noDisplayCombo = ['storedcreditcard', 'creditcard']; // don't even display the add-multi option
	this.reviewPayment = true;
	
	this.confirmedAmt =
	this.submitting = false;

	this.$addAnotherMenu = $('#payment-method-add-another');
	this.$addAnotherMenuSelect = this.$addAnotherMenu.children('select');
	this.$wrap =
	this.$amtInput =
	this.$submitWrapper =
	this.$submit =
	this.$submitContent =
	this.$submitLoading =
	this.$confirmed =
	this.$confirmedAmt =
	this.$cancel =
	this.$ppCredit = false;
    this.reviewSelector = '.';
    if (isReview)
       this.reviewSelector += 'review-';
	
	var getContainer = function() {
		return $(paypal.reviewSelector + 'payment-method-paypal-container');
	}
	
	this.init = function() {
		paypal.getContainer = getContainer;
		
		if (checkout.config.isEndeca) {
			this.$addAnotherMenu.show();
			this.$addAnotherMenuSelect.children('select option[value=paypal]').hide();
		}
		
		paypal.confirmedAmt = parseFloat(checkout.session.get('PayPalConfirmed'));

		if (payment.$methodContainer.find('div[data-method=paypal]').length) {
			paypal.addError = 'Only One PayPal Payment allowed per Order';
			return;
		}

		paypal.$wrap = $($.parseHTML(Jemplate.process('includes/partials/payment/payPal.html')));

		paypal.$submitWrapper = $('.paypal-submit-wrapper');
		paypal.$amtInput = paypal.$wrap.find('.payment-method-amount input');
		paypal.$confirmed = paypal.$wrap.find('.paypal-confirmed');
		paypal.$confirmedAmt = paypal.$wrap.find('.paypal-confirmed-amount');
		paypal.$cancel = paypal.$wrap.find('.paypal-confirmed-cancel');

		paypal.$submit =
			paypal.$wrap.find('.paypal-submit')
			.add(payment.$wrap.find('.paypal-submit'));

		paypal.$submitContent = paypal.$submit.find('.paypal-submit-content');
		paypal.$submitLoading = paypal.$submit.find('.paypal-submit-loading');

		paypal.listen();

		if (paypal.confirmedAmt) { 
			// paypal.disableOtherStep(checkout.billship, 'Billing or Shipping Information');
			// paypal.disableOtherStep(checkout.cart.shipping, 'Shipping Information');
			paypal.$amtInput.val(paypal.confirmedAmt.toMoney());
			paypal.$amtInput.attr('disabled', 'disabled');
			paypal.$confirmedAmt.html(paypal.confirmedAmt.toMoney());
			paypal.toggleSubmit(false);
			paypal.$confirmed.show();
		} else
			if (checkout.payment && checkout.payment.methods) 
			paypal.toggleSubmit(true);

	};

    this.buildReview = function() {
        var card = paypal;
        var data = {
                    method: 'paypal',
                    method_name: card.label,
                    payment_amount: checkout.payment.getMethodAmt( card ),
                };
        return data;
    };



	this.toggleSubmit = function(show) {
		if (show) {
			paypal.toggleSubmitLoading(false);
			checkout.$submit.hide();
			if (checkout.config.isEndeca) {
				paypal.$submitWrapper.show();
			} else {
				paypal.$submit.show();
			}
		} else {
			if (checkout.config.isEndeca) {
				paypal.$submitWrapper.hide();
				paypal.$ppCredit.hide();
			} else {
				paypal.$submit.hide();
			}
			checkout.$submit.show();
		}
	};

	this.toggleSubmitLoading = function(loading) {
		if (loading) {
			paypal.$submit.addClass('btn-green');
			if (checkout.config.isEndeca) {
				paypal.$ppCredit.hide();
			}
			paypal.$submitContent.hide();
			paypal.$submitLoading.show();
		} else {
			paypal.$submit.removeClass('btn-green');
			paypal.$submitLoading.hide();
			paypal.$submitContent.show();
		}
	};

	this.listen = function() {
		paypal.$submit.click(paypal.submit);
		paypal.$cancel.click(function() { paypal.cancel() });
		paypal.$wrap.find('.payment-method-amount').click(paypal.showHowToCancel);
	};

	this.disableOtherStep = function(step, stepLabel) {
		step.disable(
			$('<span>To Edit this ' + stepLabel + '</span>')
				.append(paypal.$cancel.clone(true))
		);
	};

	this.submit = function(e) {
		payment.removeFieldError(paypal.$submit);
		paypal.$submit.attr('disabled', 'disabled');
		paypal.submitting = true;

		//var	$submitButton = $(e.target || e.srcElement).closest('.paypal-submit');
		if ( payment && payment.methods && Object.keys(payment.methods).length == 1 && $('#payment-method-paypal:visible').length ) {
			payment.removeMethod(Object.keys( payment.methods)[0]);
			payment.addMethod( "paypal", (parseFloat(payment.cart_totals.values.remaining) || 0), 0 );
			paypal = payment.methods[ Object.keys( payment.methods )[0] ];
			paypal.$submit.attr('disabled', 'disabled');
			paypal.submitting = true;
		}

		if (payment.validateMethod(paypal)) {
			paypal.toggleSubmitLoading(true);
			checkout.submit(paypal.submitFail, true);
			if (checkout.config.isEndeca) {
				checkout.paypalCheckout.submit();
			}
		} else {
			paypal.submitFail();
		}
	};

	this.submitFail = function() {
		paypal.toggleSubmitLoading(false);
		paypal.$submit.removeAttr('disabled');
		paypal.submitting = false;
	};

	this.afterRemoved = function() {

		if (paypal.confirmedAmt)
			paypal.cancel(true);
		else
			paypal.toggleSubmit(false);

	};

	this.cancel = function(removed) {
		if (!paypal.confirmedAmt)
			return;


		paypal.confirmedAmt = false;

		checkout.session.set({
			'PayPalConfirmed': 0,
			'step': 'billship'
		});
		checkout.remote.call({
			'data': {
				'step': 'paypal',
				'action': 'cancel'
			}
		});
		
		/*
		checkout.billship.enable();
		checkout.cart.shipping.enable();
		// set confirm email to email if unset
		if (! checkout.billship.$verifyEmail.val() &&
			checkout.billship.$billing && checkout.billship.$billing.email.val() )
			checkout.billship.$verifyEmail.val( 
				checkout.billship.$billing.email.val()
			);

		if (removed)
			paypal.toggleSubmit(false);
		else {
			paypal.$amtInput.removeAttr('disabled');
			paypal.$confirmed.hide();
			paypal.toggleSubmit(true);
			paypal.$confirmedAmt.html('');
		}
		*/
	};

	this.afterChangeAmt = function(amount) {

		if (
			paypal.confirmedAmt
			&& paypal.confirmedAmt != amount
		) {
			// paypal.cancel();
			// return;
			paypal.confirmedAmt = amount;
			paypal.$confirmedAmt.html(paypal.confirmedAmt.toMoney());
		}
	};

	this.showHowToCancel = function(e) {
		var $target = $(e.target || e.srcElement);

		if (
			!paypal.confirmedAmt
			|| $target.hasClass('tooltip')
			|| $target.parents('.tooltip').length
			|| $target.hasClass('payment-method-remove')
			|| $target.parents('.payment-method-remove').length
		)
			return;

		payment.fieldError(
			paypal.$amtInput,
			'To change the payment amount, click ' + paypal.$cancel.text() + ' below'
		);

	};

	this.getData = function() {
		return {};
	};

	this.validate = function() {
		if (
			!paypal.submitting
			&& !paypal.confirmedAmt
		) {
			payment.fieldError(paypal.$submit, 'PayPal Checkout Required');
			return false;
		}

		return true;
	};

	this.init();
};

